<div class="input-select" ngClass="{{!!displayLabel ? 'form-group' : ''}} {{ displayFieldCss() }} {{ cls }}">
  <label [ngClass]="isRequired() ? 'required ' + clsLabel : clsLabel"
    [for]="id" *ngIf="!!displayLabel">
    {{displayLabel}}<span class="required-alert" *ngIf="!!isRequired()">*</span>
  </label>
  <div class="col-form-input input-group" ngClass="{{rightText ? 'input-group' : ''}}">
    <div class="input-group-prepend">
      <button *ngFor="let action of leftBtnActions"
        class="btn" type="button" [ngClass]="action.clsBtn"
        [title]="action.title" tabindex="-1"
        [disabled]="action.disabled"
        [hidden]="!action?.clickEvent"
        (click)="action?.clickEvent($event, action.item, action.index)">
        <i [ngClass]="action.clsIcon" aria-hidden="true"></i>
      </button>
    </div>
    <input #input [id]="id" class="form-control"
      [ngClass]="isRequired() && !!textSearch && !value ? 'no-selected' : ''"
      title="{{isRequired() && !!textSearch && !value ? 'Selecione um item da lista' : ''}}"
      [container]="container"
      [ngModel]="textSearch"
      (ngModelChange)="setTextSearch($event)"
      [typeaheadOptionField]="displayField"
      [typeaheadGroupField]="groupField"
      [typeahead]="suggestions$"
      [typeaheadAsync]="true"
      [typeaheadWaitMs]="100"
      [placeholder]="placeholder ? placeholder : displayLabel || ''"
      (typeaheadOnBlur)="onBlur($event)"
      (blur)="onBlur($event)"
      (typeaheadOnSelect)="onSelect($event)"
      [typeaheadMinLength]="minLengthToSearch"
      [typeaheadOrderBy]="sortConfig"
      [required]="isRequired()"
      [readOnly]="readOnly"
      [disabled]="disabled"
      [isAnimated]="false"
      [ngClass]="touched ? 'ng-touched ' + clsInput  : clsInput"
      [typeaheadIsFirstItemActive]="isFirstItemActive"
      (typeaheadNoResults)="onNoResults.emit($event)"
      [typeaheadScrollable]="true"
      [typeaheadOptionsInScrollableView]="10"
      [typeaheadItemTemplate]="itemTemplate"
    >
    <i class="fas fa-folder-open" title='Abrir registro' (click)="openClick($event)" *ngIf="!!showOpenButton"></i>
    <i class="fas fa-plus" title='"{{textSearch | uppercase}}": não encontrado. Clique para adicionar.'
      (click)="addClick($event)" *ngIf="!!showAddButton">
    </i>
    <span class="input-group-text" *ngIf="rightText">{{ rightText }}</span>
    <ng-content></ng-content>
  </div>
</div>
